var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from "react";
import styled from "styled-components";
import { color, font } from "../templates/ui";
import ArrowRight from "./icons/ArrowRight";
import { getAppThemeName } from "../../Services/appTheme";
const StepWrapper = styled.div `
    display: flex;
    height: 100%;
    justify-content: space-around;
    flex: 1;

    &:last-child {
        .arrow {
            display: none;
        }
    }
`;
const StyledStepItem = styled.div `
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 134px;
`;
const StepNumberItem = styled.div `
    position: relative;
    display: flex;
    justify-content: center;
    align-items: center;
    margin-bottom: 10px;
    height: 60px;
    width: 60px;
    border-radius: 50%;
    border: 1px solid
        ${(props) => {
    if (props.isActive) {
        return props.theme.primary;
    }
    if (props.isCompleted) {
        return props.theme.tertiary;
    }
    return color.gray.base;
}};
    background-color: ${(props) => {
    if (props.isActive && props.appTheme === "invoned") {
        return props.theme.primary;
    }
    if (props.isCompleted && props.appTheme === "invoned") {
        return props.theme.primary;
    }
    if (props.isActive) {
        return props.theme.primary;
    }
    if (props.isCompleted) {
        return props.theme.tertiary;
    }
    if (props.appTheme === "invoned") {
        return "white";
    }
    return "transparent";
}};
`;
const StyledNumber = styled.span `
    user-select: none;
    font-weight: 600;
    font-size: ${font.xlarge};
    color: ${(props) => {
    if (props.isActive || props.isCompleted) {
        return color.body.base;
    }
    return color.gray.dark;
}};
`;
const StepText = styled.div `
    font-weight: 700;
    text-align: center;
    font-size: ${font.small};
    line-height: 0.9rem;
    color: ${(props) => {
    if (props.isActive && props.appTheme === "invoned") {
        return props.theme.primary;
    }
    if (props.isCompleted && props.appTheme === "invoned") {
        return props.theme.primary;
    }
    if (props.isActive) {
        return props.theme.primary;
    }
    if (props.isCompleted) {
        return props.theme.tertiary;
    }
    if (props.appTheme === "invoned") {
        return "white";
    }
    return color.gray.dark;
}};
`;
const StyledArrowRight = styled(({ appTheme, ...props }) => (React.createElement(ArrowRight, Object.assign({}, props)))) `
    fill: ${(props) => {
    if (props.appTheme === "invoned") {
        return "white";
    }
    return color.gray.base;
}};
    height: 13px;
    width: 13px;
    margin-top: 19px;
`;
const Checkmark = styled.div `
    position: absolute;
    right: -2px;
    top: 0;
    width: 24px;
    height: 24px;
    border-radius: 50%;
    background-color: ${color.body.base};

    &:before {
        position: absolute;
        border-radius: 50%;
        background-color: ${color.secondary.base};
        content: "";
        height: calc(100% - 4px);
        width: calc(100% - 4px);
        top: 2px;
        left: 2px;
        z-index: 1;
    }

    &:after {
        position: absolute;
        content: "";
        width: 13px;
        height: 12px;
        left: 5px;
        top: 8px;
        background-repeat: no-repeat;
        background-image: url(data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0idXRmLTgiPz48c3ZnIHZlcnNpb249IjEuMSIgaWQ9IkxheWVyXzEiIHhtbG5zOmNjPSJodHRwOi8vY3JlYXRpdmVjb21tb25zLm9yZy9ucyMiIHhtbG5zOmRjPSJodHRwOi8vcHVybC5vcmcvZGMvZWxlbWVudHMvMS4xLyIgeG1sbnM6aW5rc2NhcGU9Imh0dHA6Ly93d3cuaW5rc2NhcGUub3JnL25hbWVzcGFjZXMvaW5rc2NhcGUiIHhtbG5zOnJkZj0iaHR0cDovL3d3dy53My5vcmcvMTk5OS8wMi8yMi1yZGYtc3ludGF4LW5zIyIgeG1sbnM6c29kaXBvZGk9Imh0dHA6Ly9zb2RpcG9kaS5zb3VyY2Vmb3JnZS5uZXQvRFREL3NvZGlwb2RpLTAuZHRkIiB4bWxuczpzdmc9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIiB4PSIwcHgiIHk9IjBweCIgdmlld0JveD0iMCAwIDc4LjMgNTQuMSIgc3R5bGU9ImVuYWJsZS1iYWNrZ3JvdW5kOm5ldyAwIDAgNzguMyA1NC4xOyIgeG1sOnNwYWNlPSJwcmVzZXJ2ZSI+PHN0eWxlIHR5cGU9InRleHQvY3NzIj4uc3Qwe2ZpbGw6I0ZGRkZGRjt9PC9zdHlsZT48ZyB0cmFuc2Zvcm09InRyYW5zbGF0ZSgwLC05NTIuMzYyMTgpIj48cGF0aCBjbGFzcz0ic3QwIiBkPSJNNzEuMSw5NTIuNGMtMS44LDAuMS0zLjUsMC44LTQuOCwyLjFsLTM1LjYsMzUuNkwxMS41LDk3NWMtMi45LTIuNS03LjQtMi4yLTkuOSwwLjhzLTIuMiw3LjQsMC44LDkuOWMwLjEsMC4xLDAuMywwLjIsMC40LDAuM2wyNCwxOWMyLjgsMi4yLDYuOCwyLDkuMy0wLjVsNDAtNDBjMi44LTIuNywyLjktNy4xLDAuMi05LjlDNzQuOSw5NTMuMSw3Myw5NTIuMyw3MS4xLDk1Mi40TDcxLjEsOTUyLjR6Ii8+PC9nPjwvc3ZnPg==);
        z-index: 2;
    }
`;
const FormStep = ({ label, number, isActive, isCompleted, }) => (React.createElement(StepWrapper, null,
    React.createElement(StyledStepItem, null,
        React.createElement(StepNumberItem, { isActive: isActive, isCompleted: isCompleted, appTheme: getAppThemeName() },
            React.createElement(StyledNumber, { isActive: isActive, isCompleted: isCompleted },
                number,
                isCompleted && React.createElement(Checkmark, null))),
        React.createElement(StepText, { isActive: isActive, isCompleted: isCompleted, appTheme: getAppThemeName() }, label)),
    React.createElement(StyledArrowRight, { className: "arrow", appTheme: getAppThemeName() })));
export default FormStep;
